export { default, getServerSideProps } from '../index'
